/* Please add events to this file first:
* https://docs.google.com/spreadsheets/d/1ybCfEav51tH6XZgK9txb7c1Hb6r6XU3df8mR6iSN38g/edit#gid=1749367034
*/

const DASHBOARD_ID = 100;
const DASHBOARD_SIDEBAR_ID = 101;
const LANDING_PAGE_ID = 102;
const HOME_PAGE_ID = 103;
const PRODUCT_PAGE_ID = 104;
const COLLECTION_PAGE_ID = 105;
const BLOG_POST_ID = 106;
const TEMPLATE_LIST_ID = 107;
const TEMPLATE_PREVIEW_ID = 108;
const PRODUCT_ASSIGNMENT_ID = 114;


function generateEventId(groupId, eventIndex) {
  return parseInt(groupId + eventIndex.toString().padStart(4, 0));
}

export const DASHBOARD_EVENT = {
  VIEWED: generateEventId(DASHBOARD_ID, 1),
  CREATE_NEW_CLICKED: generateEventId(DASHBOARD_ID, 2),
  CREATE_NEW_POPUP_VIEWED: generateEventId(DASHBOARD_ID, 3),
  CREATE_LANDING_PAGE_CLICKED: generateEventId(DASHBOARD_ID, 4),
  CREATE_HOME_PAGE_CLICKED: generateEventId(DASHBOARD_ID, 5),
  CREATE_PRODUCT_PAGE_CLICKED: generateEventId(DASHBOARD_ID, 6),
  CREATE_COLLECTION_PAGE_CLICKED: generateEventId(DASHBOARD_ID, 7),
  CREATE_BLOG_POST_CLICKED: generateEventId(DASHBOARD_ID, 8),
}
export const DASHBOARD_SIDEBAR_EVENT = {
  CREATE_NEW_LANDING_PAGE_SHORTCUT_CLICKED: generateEventId(DASHBOARD_SIDEBAR_ID, 1),
  CREATE_NEW_HOME_PAGE_SHORTCUT_CLICKED: generateEventId(DASHBOARD_SIDEBAR_ID, 2),
  CREATE_NEW_PRODUCT_PAGE_SHORTCUT_CLICKED: generateEventId(DASHBOARD_SIDEBAR_ID, 3),
  CREATE_NEW_COLLECTION_PAGE_SHORTCUT_CLICKED: generateEventId(DASHBOARD_SIDEBAR_ID, 4),
  CREATE_NEW_BLOG_POST_SHORTCUT_CLICKED: generateEventId(DASHBOARD_SIDEBAR_ID, 5),
  TRIAL_SURVEY_MESSAGE_SUBMITTED: generateEventId(DASHBOARD_SIDEBAR_ID, 6)
}
export const LANDING_PAGE_EVENT = {
  VIEWED: generateEventId(LANDING_PAGE_ID, 1),
  CREATE_NEW_CLICKED: generateEventId(LANDING_PAGE_ID, 2),
  TEMPLATE_VIEWED: generateEventId(LANDING_PAGE_ID, 3),
  CREATE_BLANK_CLICKED: generateEventId(LANDING_PAGE_ID, 4),
  CREATE_FROM_TEMPLATE_CLICKED: generateEventId(LANDING_PAGE_ID, 5),
  DUPLICATE: generateEventId(LANDING_PAGE_ID, 6),
  DUPLICATE_TO: generateEventId(LANDING_PAGE_ID, 7),
}
export const HOME_PAGE_EVENT = {
  VIEWED: generateEventId(HOME_PAGE_ID, 1),
  CREATE_NEW_CLICKED: generateEventId(HOME_PAGE_ID, 2),
  MAKE_DEFAULT_CLICKED: generateEventId(HOME_PAGE_ID, 3),
  TEMPLATE_VIEWED: generateEventId(HOME_PAGE_ID, 4),
  CREATE_BLANK_CLICKED: generateEventId(HOME_PAGE_ID, 5),
  CREATE_FROM_TEMPLATE_CLICKED: generateEventId(HOME_PAGE_ID, 6),
  DUPLICATE: generateEventId(HOME_PAGE_ID, 7),
  DUPLICATE_TO: generateEventId(HOME_PAGE_ID, 8),
}
export const PRODUCT_PAGE_EVENT = {
  VIEWED: generateEventId(PRODUCT_PAGE_ID, 1),
  CREATE_NEW_CLICKED: generateEventId(PRODUCT_PAGE_ID, 2),
  MAKE_DEFAULT_CLICKED: generateEventId(PRODUCT_PAGE_ID, 3),
  OPEN_ADD_PRODUCT_POPUP_CLICKED: generateEventId(PRODUCT_PAGE_ID, 4),
  ADD_PRODUCT_CLICKED: generateEventId(PRODUCT_PAGE_ID, 5),
  TEMPLATE_VIEWED: generateEventId(PRODUCT_PAGE_ID, 6),
  CREATE_BLANK_CLICKED: generateEventId(PRODUCT_PAGE_ID, 7),
  CREATE_FROM_TEMPLATE_CLICKED: generateEventId(PRODUCT_PAGE_ID, 8),
  DUPLICATE: generateEventId(PRODUCT_PAGE_ID, 9),
  DUPLICATE_TO: generateEventId(PRODUCT_PAGE_ID, 10),
}
export const COLLECTION_PAGE_EVENT = {
  VIEWED: generateEventId(COLLECTION_PAGE_ID, 1),
  CREATE_NEW_CLICKED: generateEventId(COLLECTION_PAGE_ID, 2),
  MAKE_DEFAULT_CLICKED: generateEventId(COLLECTION_PAGE_ID, 3),
  OPEN_ADD_COLLECTION_POPUP_CLICKED: generateEventId(COLLECTION_PAGE_ID, 4),
  ADD_COLLECTION_CLICKED: generateEventId(COLLECTION_PAGE_ID, 5),
  TEMPLATE_VIEWED: generateEventId(COLLECTION_PAGE_ID, 6),
  CREATE_BLANK_CLICKED: generateEventId(COLLECTION_PAGE_ID, 7),
  CREATE_FROM_TEMPLATE_CLICKED: generateEventId(COLLECTION_PAGE_ID, 8),
  DUPLICATE: generateEventId(COLLECTION_PAGE_ID, 9),
  DUPLICATE_TO: generateEventId(COLLECTION_PAGE_ID, 10),
}
export const BLOG_POST_EVENT = {
  VIEWED: generateEventId(BLOG_POST_ID, 1),
  CREATE_NEW_CLICKED: generateEventId(BLOG_POST_ID, 2),
  TEMPLATE_VIEWED: generateEventId(BLOG_POST_ID, 3),
  CREATE_BLANK_CLICKED: generateEventId(BLOG_POST_ID, 4),
  CREATE_FROM_TEMPLATE_CLICKED: generateEventId(BLOG_POST_ID, 5),
  DUPLICATE: generateEventId(BLOG_POST_ID, 6),
  DUPLICATE_TO: generateEventId(BLOG_POST_ID, 7),
}
export const TEMPLATE_LIST_EVENT = {
  VIEWED: generateEventId(TEMPLATE_LIST_ID, 1),
  CREATE_NEW_PAGE_CLICKED: generateEventId(TEMPLATE_LIST_ID, 2),
  START_EDITING_CLICKED: generateEventId(TEMPLATE_LIST_ID, 3),
  PREVIEW_CLICKED: generateEventId(TEMPLATE_LIST_ID, 4)
}
export const DESIGNED_TEMPLATE_PREVIEW_EVENT = {
  VIEWED: generateEventId(TEMPLATE_PREVIEW_ID, 1),
  START_EDITING_CLICKED: generateEventId(TEMPLATE_PREVIEW_ID, 2),
  CLOSE_CLICKED: generateEventId(TEMPLATE_PREVIEW_ID, 3)
}

export const PRODUCT_ASSIGNMENT_EVENT = {
  OPEN_ASSIGN_POPUP_FROM_PAGE_LIST:  generateEventId(PRODUCT_ASSIGNMENT_ID, 7),
  SELECT_ALL_PRODUCTS:  generateEventId(PRODUCT_ASSIGNMENT_ID, 8),
  SELECT_SHOPIFY_COLLECTIONS:  generateEventId(PRODUCT_ASSIGNMENT_ID, 9),
  SELECT_PRODUCT_TEMPLATES:  generateEventId(PRODUCT_ASSIGNMENT_ID, 10),
  CONFIRM_ASSIGNMENT:  generateEventId(PRODUCT_ASSIGNMENT_ID, 11),
}


// TrackEvent GemPages 7
const PAGE_CREATION_WORKFLOW = 701;
export const PAGE_CREATION_WORKFLOW_EVENT = { 
  DASHBOARD_CREATE_PAGE: generateEventId(PAGE_CREATION_WORKFLOW, 1),
}
